/* eslint-disable */
import React from 'react';

import styles from './NoStoreSelected.module.scss';

import NoStore from '../../../assets/images/noStore.png';
import { useTranslation } from 'react-i18next';
import { appConfig } from '../../../config/app-config';
let url = appConfig.apiUrls.micro
url = appConfig.apiUrls.micro.replace('/api', '')

export const NoStoreSelected = () => {
  const{t} = useTranslation('calendar')
  return (
    <div className={styles.noStoreSelected}>
      <img src={`${url}${NoStore}`} alt="No Store Selected" />
      <h1>{t("No Store Selected")}</h1>
      <span>{t('Please select one of your stores to view the daily activities')}</span>
    </div>
  );
};
